/* Hide sticky ATC at the footer and while the story CTA is visible on mobile. */
(function(){
 'use strict';
 function setup(){
  if(!document.querySelector('.sticky-atc'))return;
  var footer=document.querySelector('footer, .footer, #shopify-section-footer');
  var storyCta=document.querySelector('.orv-story__cta');
  var frame=0;
  function update(){
   frame=0;
   var footerVisible=false,ctaVisible=false;
   if(footer){var r=footer.getBoundingClientRect();footerVisible=r.top<window.innerHeight-88&&r.bottom>0;}
   if(storyCta&&window.matchMedia('(max-width:749px)').matches){var c=storyCta.getBoundingClientRect();ctaVisible=c.top<window.innerHeight-96&&c.bottom>96;}
   document.body.classList.toggle('orv-v49-hide-sticky',footerVisible||ctaVisible);
  }
  function request(){if(!frame)frame=requestAnimationFrame(update);}
  window.addEventListener('scroll',request,{passive:true});window.addEventListener('resize',request,{passive:true});
  update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
